var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-center"},[_c('div',[_c('Header'),_c('ResponsiveAuth',[_c('Login')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }